import React from "react";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

import Dropzone from 'react-dropzone';
import StdButton from './stdbutton.jsx';

class CsvDropzone extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            files: [],
            metadata: [],
            uploadNotice: null
        };

        this.setState = this.setState.bind(this);

        this.updateMetadata = this.updateMetadata.bind(this);
        this.handleDrop = this.handleDrop.bind(this);

        this.handleUpload = this.handleUpload.bind(this);
        this.onUploadResult = this.onUploadResult.bind(this);
    }

    updateMetadata(obj, index){
        var metadata = this.state.metadata;
        metadata[index] = obj;
        this.setState({ metadata: metadata });
    }

    handleDrop(files) {
        var metadata = [];
        var that = this;
        files.forEach((file, index) => {
            metadata.push({
                isReady: false
            });
            var fileReader = new FileReader();
            fileReader.addEventListener("load", function(event) {
                var lines = fileReader.result.split("\n").filter(line => { return line.trim().length > 0 });
                var labels = lines[0].toLowerCase().split(",");
                labels = labels.map(label => label.trim());
                var missingColumns = [];
                that.props.columns.forEach(column => { if (!labels.includes(column)) { missingColumns.push(column) } });
                if (missingColumns.length>0) {
                    that.updateMetadata({ isReady: true, status: false, linesNum: (lines.length-1), missing: missingColumns }, index);
                } else {
                    that.updateMetadata({ isReady: true, status: true, linesNum: (lines.length-1) }, index);
                }

            });
            fileReader.readAsText(file);

        });
        this.setState({
            files: files, metadata: metadata, uploadNotice: null
        });
    }

    handleRemoveFile(index){
        const { files, metadata } = this.state;
        files.splice(index,1);
        metadata.splice(index,1);
        this.setState({ files: files, metadata: metadata, uploadNotice: null });
    }

    handleUpload(){
        if (this.state.files.length==0) {
            this.setState({ uploadNotice: 'Please select CSV file.' });
        } else if (this.state.files.length>1) {
            this.setState({ uploadNotice: 'Please keep only one file for upload.' });
        } else if (!this.state.metadata[0].status) {
            this.setState({ uploadNotice: 'Please select valid file.' });
        } else {
            this.setState({ uploadNotice: 'Uploading file to server...' });
            var data = new FormData();
            data.append("file", this.state.files[0]);
            doPostForm(this.props.endpoint, data, this.onUploadResult);
        }
    }

    onUploadResult(result){
        if (result.isDone) {
            this.setState({ files: [], metadata: [], uploadNotice: null });
            this.props.onSuccess();
        } else {
            this.setState({ uploadNotice: result.error.message });
        }
    }

    render(){
        const { error, isLoaded, files, metadata } = this.state;
        var allDone = metadata.length==0 || metadata.every(e => { return e.isReady });
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose} style={{ minWidth: 600 }}
                aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
                <DialogContent>
                    <Dropzone onDrop={this.handleDrop.bind(this)} multiple={false}>
                        {({getRootProps,getInputProps}) => (
                            <div>
                                {this.state.files.length>0 ? (
                                    <div {...getRootProps()} style={{ border: '2px solid #dfdfdf', marginTop: 10, marginBottom: 20 }}>
                                        <Table padding="dense">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>File</TableCell>
                                                    <TableCell>Size</TableCell>
                                                    <TableCell>Status</TableCell>
                                                    <TableCell>&nbsp;</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {files.map((file, index) => (
                                                    <TableRow key={file.name}>
                                                        <TableCell>{file.name}</TableCell>
                                                        <TableCell>{file.size} bytes</TableCell>
                                                        <TableCell>{metadata[index].isReady ? (
                                                            <span>
                                                                                {metadata[index].status ? (
                                                                                    <span>OK, {metadata[index].linesNum} rows</span>
                                                                                ):(
                                                                                    <span>Columns do not match</span>
                                                                                )}
                                                                                </span>
                                                        ):(
                                                            <span>Checking...</span>
                                                        )}</TableCell>
                                                        <TableCell>
                                                            {allDone && (
                                                                <DeleteForeverIcon onClick={this.handleRemoveFile.bind(this, index)} />
                                                            )}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </div>
                                ):(
                                    <div {...getRootProps()} style={{ background: '#f7f7f7', border: '2px solid #dfdfdf', marginTop: 10, marginBottom: 20, padding: 10, textAlign: 'center' }}>
                                        <div>
                                            <input {...getInputProps()} />
                                            <div>Drop a CSV here <br/>or click to select a file</div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </Dropzone>
                    <DialogContentText>
                        {this.state.uploadNotice ? (
                            <span>{this.state.uploadNotice}</span>
                        ):(
                            <span>We're expecting the following columns: <strong>title</strong>, <strong>group</strong>, <strong>description</strong>.</span>
                        )}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <StdButton label="Cancel" type="alt" onClick={this.props.onClose}/>
                    <StdButton label="Upload" onClick={this.handleUpload}/>
                </DialogActions>
            </Dialog>
        )
    }
}

export default CsvDropzone;